import { GRAMMAR_SESSION_KINDS } from '@repo/config';
import { z } from 'zod';
import { grammarSubmittedAnswerSchema } from '../schemas';

const grammarSessionV2ResultSchema = z.object({
  itemId: z.number().int().positive(),
  attempt: z.union([z.literal(1), z.literal(2)]),
  latencyMs: z.number().int().min(0).optional(),
  response: grammarSubmittedAnswerSchema,
});

const saveGrammarSessionV2RequestSchemaDefinition = z.object({
  clientSessionId: z.string().uuid(),
  sessionKind: z.enum([GRAMMAR_SESSION_KINDS[0], GRAMMAR_SESSION_KINDS[1]]),
  serveToken: z.string().min(1),
  timezone: z.string().optional(),
  results: z.array(grammarSessionV2ResultSchema).min(1).max(30),
});

export const saveGrammarSessionV2RequestSchema: typeof saveGrammarSessionV2RequestSchemaDefinition =
  saveGrammarSessionV2RequestSchemaDefinition;

export type ISaveGrammarSessionV2Request = z.infer<typeof saveGrammarSessionV2RequestSchema>;

export type IGrammarSessionV2Result = ISaveGrammarSessionV2Request['results'][number];
